import { withLDProvider } from 'launchdarkly-react-client-sdk';

import { LAUNCH_DARKLY_CLIENT_SIDE_ID } from '#src/config.ts';

// Seconds to wait for flags before rendering with default values.
// Without it, a flag request that times out never settles (the SDK ignores
// the XHR `timeout` event) and the app stays blank.
const INIT_TIMEOUT = 5;

export const withFFProvider = () =>
  withLDProvider({
    clientSideID: LAUNCH_DARKLY_CLIENT_SIDE_ID,
    timeout: INIT_TIMEOUT,
    options: {
      // Serve the flags cached from the last visit right away, then refresh
      // them in the background. Only helps logged-out users: `identify`
      // clears the cache of the shared context below.
      bootstrap: 'localStorage',
      sendEventsOnlyForVariation: true,
      // Streams only once a signed-in user is known (see StreamWhenSignedIn).
      streaming: false,
      diagnosticOptOut: true,
    },
    context: {
      kind: 'user',
      key: '00000000-0000-0000-0000-000000000000',
    },
  });
